import { useEffect, useState } from 'react';
import { View, ActivityIndicator, StyleSheet, Platform } from 'react-native';
import { Stack, useRouter, useSegments } from 'expo-router';
import Head from 'expo-router/head';
import { theme } from '@/constants/theme';
import { supabase } from '@/utils/supabase';

export default function MentorLayout() {
  const router = useRouter();
  const segments = useSegments();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    checkAuthorization();

    const { data: authListener } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_OUT') {
        setIsAuthorized(false);
        router.replace('/');
      } else if (event === 'SIGNED_IN') {
        checkAuthorization();
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  const checkAuthorization = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      const currentSegment = (segments as string[])[1] as string | undefined;

      if (!user?.email) {
        setIsAuthorized(false);
        if (currentSegment !== 'login' && currentSegment !== 'register') {
          router.replace('/');
        }
        return;
      }

      const { data: mentorData } = await supabase
        .from('mentors')
        .select('id')
        .eq('email', user.email)
        .maybeSingle();

      if (!mentorData) {
        if (currentSegment === 'register') {
          setIsAuthorized(false);
          return;
        }
        await supabase.auth.signOut();
        setIsAuthorized(false);
        router.replace('/');
        return;
      }

      setIsAuthorized(true);
      if (currentSegment === 'login' || currentSegment === 'register') {
        router.replace('/mentor/dashboard');
      }
    } catch (error) {
      console.error('Authorization check error:', error);
      setIsAuthorized(false);
      const currentSegment = (segments as string[])[1] as string | undefined;
      if (currentSegment !== 'login' && currentSegment !== 'register') {
        router.replace('/');
      }
    }
  };

  if (isAuthorized === null) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={theme.colors.primary} />
      </View>
    );
  }

  return (
    <>
      {Platform.OS === 'web' && (
        <Head>
          <meta name="robots" content="noindex, nofollow" />
        </Head>
      )}
      <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen
        name="login"
        options={{
          title: 'התחברות מנטורים | Kursi',
        }}
      />
      <Stack.Screen
        name="register"
        options={{
          title: 'הרשמה למנטורים | Kursi',
        }}
      />
      <Stack.Screen
        name="dashboard"
        options={{
          title: 'דאשבורד מנטור | Kursi',
        }}
      />
      <Stack.Screen
        name="leads"
        options={{
          title: 'ניהול לידים | Kursi',
        }}
      />
      <Stack.Screen
        name="courses"
        options={{
          title: 'הקורסים שלי | Kursi',
        }}
      />
      <Stack.Screen
        name="settings"
        options={{
          title: 'הגדרות | Kursi',
        }}
      />
    </Stack>
    </>
  );
}

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    backgroundColor: theme.colors.background,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
